// @flow
import debounce from './debounce'

/**
 * Small utility function that makes some function to be deprecated.
 * It shows error colored warning with debounce, so you wont see a lot
 * of deprecated messages, but it will bother you from time to time.
 * @param  {Function} func: Function
 * @param  {string} name: string
 * @return {Function}
 */
const deprecate = (func: Function, name: string) => {
  const printDeprecated = debounce(
    {
      wait: 700,
      leading: true,
      trailing: false,
    },
    () => {
      // eslint-disable-next-line no-console
      console.error(`Warning: the function "${name}" is deprecated!`)
    }
  )

  return (...args: any) => {
    if (process.env.NODE_ENV !== 'production') {
      printDeprecated()
    }
    return func(...args)
  }
}

export default deprecate
